// @flow
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import Header from './Header.component';

export default (injectIntl(withRouter(Header)): any);
